// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__-5tyz","inner":"Form_inner__3xgu9","range":"Form_range__2h7Ik","name":"Form_name__3Lt97","actions":"Form_actions__bEKea"};